import React from 'react';
import { useT } from '../../../i18n';

const STEPS = [
  {
    title: 'Répondez à quelques questions',
    text: 'Vos prénoms, votre date, le nombre d’invités, votre budget. Deux minutes, pas plus.',
  },
  {
    title: 'Votre mariage s’affiche, déjà organisé',
    text: 'Vos étapes sont listées et datées selon votre date, votre budget est réparti par poste. Vous ne partez pas d’une page blanche.',
  },
  {
    title: 'Vous avancez, à deux, étape par étape',
    text: 'À chaque étape, vous savez quoi faire. Vous cochez, vous ajoutez vos invités, vos prestataires, votre plan de table. Jusqu’au jour J.',
  },
];

// Section « Comment ça marche » : trois étapes numérotées.
const HowItWorks: React.FC = () => {
  const t = useT();
  return (
    <section className="mk-band" aria-labelledby="mk-how-title">
      <div className="mk-section mk-container">
        <div className="mk-section-head">
          <span className="mk-eyebrow">{t('Comment ça marche')}</span>
          <h2 id="mk-how-title" className="mk-h2">
            {t('Deux minutes pour démarrer, guidés jusqu’au jour J')}
          </h2>
        </div>
        <ol className="mk-steps-grid">
          {STEPS.map((step, i) => (
            <li key={step.title} className="mk-step">
              <span className="mk-step-num" aria-hidden="true">
                {String(i + 1).padStart(2, '0')}
              </span>
              <h3>{t(step.title)}</h3>
              <p>{t(step.text)}</p>
            </li>
          ))}
        </ol>
      </div>
    </section>
  );
};

export default HowItWorks;
